import { render, staticRenderFns } from "./XFormGroup.vue?vue&type=template&id=2c828dda&"
import script from "./XFormGroup.vue?vue&type=script&lang=js&"
export * from "./XFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports